import React, { memo } from 'react';
import { View, TextInput, TouchableOpacity, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface MarketplaceSearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  onClear: () => void;
  containerStyle?: StyleProp<ViewStyle>;
}

const MAX_SEARCH_LENGTH = 100;

export const MarketplaceSearchBar: React.FC<MarketplaceSearchBarProps> = memo(({
  value,
  onChangeText,
  onClear,
  containerStyle,
}) => {
  const { colors } = useThemeColors();
  return (
    <View style={[styles.container, { backgroundColor: colors.card.bg, borderColor: colors.card.border }, containerStyle]}>
      <RESIDENTS_SVG_COMPONENTS.MAGNIFYING_GLASS
        width={18}
        height={18}
        color={colors.text.dimmer}
      />
      <TextInput
        style={[styles.input, { color: colors.text.primary }]}
        value={value}
        onChangeText={onChangeText}
        placeholder="Search listings..."
        placeholderTextColor={colors.text.dimmer}
        maxLength={MAX_SEARCH_LENGTH}
        returnKeyType="search"
        autoCapitalize="none"
        autoCorrect={false}
        accessibilityLabel="Search marketplace listings"
        accessibilityRole="search"
      />
      {value.length > 0 && (
        <TouchableOpacity
          style={styles.clearButton}
          onPress={onClear}
          activeOpacity={0.7}
          accessibilityRole="button"
          accessibilityLabel="Clear search"
        >
          <RESIDENTS_SVG_COMPONENTS.CANCEL_X
            width={14}
            height={14}
            color={colors.text.dimmer}
          />
        </TouchableOpacity>
      )}
    </View>
  );
});

MarketplaceSearchBar.displayName = 'MarketplaceSearchBar';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 12,
    paddingLeft: 17,
    paddingRight: 12,
    height: 44,
    gap: 10,
  },
  input: {
    flex: 1,
    fontSize: 14,
    paddingVertical: 0,
  },
  clearButton: {
    padding: 4,
  },
});
